import Cloture from '@/views/consultations/cloture';

export default {
    name: 'cpn',
    components: {
        Cloture
    },
    props: [],
    data() {
        return {
            fields: ["visites", "dates", { key: 'age', label: 'Age de la grossesse' },
                'poids', { key: 'gain_poids', label: 'Gain de poids' }, 'TA', 'HU', { key: 'variation_hu', label: 'Variation HU' }, 'actions'
            ],
            fieldsSuites: [ "dates", { key: 'age', label: 'Age de la grossesse' },
            'poids', { key: 'gain_poids', label: 'Gain de poids' }, 'TA', 'HU', { key: 'variation_hu', label: 'Variation HU' }, 'actions'
            ],
            filter: "",
            perPage: 10,
            currentPage: 1,
            showSuites:false,
            consultationReference:null,
            indexConsultationReference:null,
            show: false,
            consultation: null,
            is_loading: true
        }
    },
    computed: {
        historiques() {
            return this.$store.getters["patientConsultations"];
        },
        rows() {
            return this.historiques.length;
        },
        user_role() {
            return this.userRole
        }
    },
    mounted() {
        this.$store.dispatch('getHistoriqueCpn', { id: this.$route.params.id, cpn: 'CPN' }).then(() => {
            this.is_loading = false
            console.log("HISTO: ",this.historiques)
        });
    },
    methods: {
        loadConsultation(consultation) {
            console.log(consultation)
            this.consultation = consultation
            this.show = true

        },
        closeHistorique() {
            this.show = false
            this.showSuites = false

        },

        loadSuites(consultationReference,index){
            this.consultationReference = consultationReference
            console.log("VEW SUITE: ",this.consultationReference)
            
            this.indexConsultationReference = index
            this.showSuites = true
        }
    }
}